import { EquipmentStatus } from "../types/TypeMapData";

/**
 * 指定された`SeatStatus`のリストを、10個ずつに分割し、表を生成する関数。
 * 各表は、備品名と利用状況（使用済み/総数）を表示します。
 * - リストの長さが10の倍数でない場合、最後のページは残りのアイテムだけを表示します。
 *
 * @param {EquipmentStatus[]} list - 備品の状態を表すオブジェクトのリスト
 * @returns {Array} - 各ページに対応するHTMLテーブルを含むオブジェクトのリスト
 */

export const generateUsageInfoList = (list: EquipmentStatus[]) => {
  let countList = Math.ceil(list.length / 10);
  let json = [];
  for (let i = 0; i < countList; i++) {
    if (i !== countList - 1) {
      let digit;
      if (i === 0) {
        digit = 0;
      } else {
        digit = i * 10;
      }
      json.push({
        content: (
          <div>
            <table>
              <tbody>
                <tr>
                  <th className="table_main">備品名</th>
                  <th className="sub">
                    <span>利用状況</span>
                  </th>
                  <th className="table_main">備品名</th>
                  <th className="sub">
                    <span>利用状況</span>
                  </th>
                </tr>
                <tr>
                  <td className="table_main">{list[digit].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit].object_total_count}
                    </span>
                  </td>
                  <td className="table_main">{list[digit + 1].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 1].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 1].object_total_count}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table_main">{list[digit + 2].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 2].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 2].object_total_count}
                    </span>
                  </td>
                  <td className="table_main">{list[digit + 3].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 3].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 3].object_total_count}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table_main">{list[digit + 4].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 4].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 4].object_total_count}
                    </span>
                  </td>
                  <td className="table_main">{list[digit + 5].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 5].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 5].object_total_count}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table_main">{list[digit + 6].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 6].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 6].object_total_count}
                    </span>
                  </td>
                  <td className="table_main">{list[digit + 7].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 7].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 7].object_total_count}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table_main">{list[digit + 8].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 8].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 8].object_total_count}
                    </span>
                  </td>
                  <td className="table_main">{list[digit + 9].item_name}</td>
                  <td className="table_sub">
                    <span className="molecule">
                      {list[digit + 9].object_used_count}
                    </span>
                    <span className="slash">/</span>
                    <span className="denominator">
                      {list[digit + 9].object_total_count}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      });
    } else {
      let amari = list.length % 10;
      let digit;
      if (i === 0) {
        digit = 0;
      } else {
        digit = i * 10;
      }
      let content = (
        <div>
          <table>
            <tbody>
              <tr>
                <th className="table_main">備品名</th>
                <th className="table_sub">
                  <span>利用状況</span>
                </th>
                <th className="table_main">備品名</th>
                <th className="table_sub">
                  <span>利用状況</span>
                </th>
              </tr>
              <tr>
                <td className="table_main">
                  {(() => {
                    if (amari > 0) {
                      return list[digit + 0].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 0) {
                        return list[digit + 0].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 0) {
                        return list[digit + 0].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>
                <td className="table_main">
                  {(() => {
                    if (amari > 1) {
                      return list[digit + 1].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 1) {
                        return list[digit + 1].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 1) {
                        return list[digit + 1].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="table_main">
                  {(() => {
                    if (amari > 2) {
                      return list[digit + 2].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 2) {
                        return list[digit + 2].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 2) {
                        return list[digit + 2].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>

                <td className="table_main">
                  {(() => {
                    if (amari > 3) {
                      return list[digit + 3].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 3) {
                        return list[digit + 3].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 3) {
                        return list[digit + 3].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="table_main">
                  {(() => {
                    if (amari > 4) {
                      return list[digit + 4].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 4) {
                        return list[digit + 4].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 4) {
                        return list[digit + 4].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>

                <td className="table_main">
                  {(() => {
                    if (amari > 5) {
                      return list[digit + 5].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 5) {
                        return list[digit + 5].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 5) {
                        return list[digit + 5].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="table_main">
                  {(() => {
                    if (amari > 6) {
                      return list[digit + 6].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 6) {
                        return list[digit + 6].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 6) {
                        return list[digit + 6].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>

                <td className="table_main">
                  {(() => {
                    if (amari > 7) {
                      return list[digit + 7].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 7) {
                        return list[digit + 7].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 7) {
                        return list[digit + 7].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="table_main">
                  {(() => {
                    if (amari > 8) {
                      return list[digit + 8].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 8) {
                        return list[digit + 8].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 8) {
                        return list[digit + 8].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>

                <td className="table_main">
                  {(() => {
                    if (amari > 9) {
                      return list[digit + 9].item_name;
                    } else {
                      return "";
                    }
                  })()}
                </td>
                <td className="table_sub">
                  <span className="molecule">
                    {(() => {
                      if (amari > 9) {
                        return list[digit + 9].object_used_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                  <span className="slash">/</span>
                  <span className="denominator">
                    {(() => {
                      if (amari > 9) {
                        return list[digit + 9].object_total_count;
                      } else {
                        return "";
                      }
                    })()}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );

      json.push({
        content: content,
      });
    }
  }
  return json;
};
